module.exports = __webpack_public_path__ + "img/face1.b8b6c5a8.png";